import type { i18n as I18n } from 'i18next';

const reloaded = new Set<string>();

/**
 * Fetches a namespace again, at most once per page load per language.
 *
 * A portal tab keeps the copy it loaded at start-up, while the API is
 * redeployed under it; a line type added by the new API then has no words in
 * the old copy. The locale files are served with `no-cache`, so one reload
 * picks up the release's copy. Once only: a key that is genuinely missing
 * must not turn into a request loop.
 */
export function reloadNamespaceOnce(i18n: I18n, namespace: string): void {
  const key = `${i18n.language}:${namespace}`;
  if (reloaded.has(key)) return;
  reloaded.add(key);
  void i18n.reloadResources([i18n.language], [namespace]);
}

/** Test seam: forget which namespaces were reloaded. */
export function resetNamespaceReloads(): void {
  reloaded.clear();
}
